import { Heart } from "lucide-react";
import { Reveal } from "./Reveal";
import { PILLARS, SERVICE_CARDS } from "../data/content";

export const Services = () => (
  <section className="section section-alt" id="services" data-testid="services-section">
    <div className="wrap">
      <Reveal className="section-head">
        <span className="eyebrow"><span className="sq" /> What We Do</span>
        <h2 data-testid="services-heading">30+ Creative &amp; AI Services</h2>
        <p>Powering brands for the future — across strategy, creative, digital and AI &amp; automation.</p>
        <p data-testid="services-ai-note">AI is built into how we work, from AI video and ad creatives to automated content workflows, so
          you get more creative output without losing craft.</p>
      </Reveal>

      <Reveal delay={80}>
        <div className="service-pillars" data-testid="service-pillars">
          {PILLARS.map((p) => (
            <div className="pillar" key={p.title} data-testid={`pillar-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <h4>{p.title}</h4>
              <ul>
                {p.items.map((it) => <li key={it}>{it}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={140}>
        <div className="service-grid" data-testid="service-grid">
          {SERVICE_CARDS.map((s) => (
            <div className="service-card" key={s.title} data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <div className="heart"><Heart size={18} fill="currentColor" strokeWidth={0} /></div>
              <h4>{s.title}</h4>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
